import { type ReactNode } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { clearSession, getSession } from "../auth";

export function Layout({ children }: { children: ReactNode }) {
  const session = getSession();
  const location = useLocation();
  const navigate = useNavigate();

  const onLogout = () => {
    clearSession();
    navigate("/login", { replace: true });
  };

  return (
    <div className="min-h-screen flex flex-col">
      <header className="bg-gray-800 border-b border-gray-700 sticky top-0 z-10">
        <div className="max-w-3xl mx-auto px-4 py-3 flex items-center gap-4">
          <h1 className="text-lg font-semibold tracking-tight">Babel</h1>
          <nav className="flex gap-3 ml-2 text-sm">
            <Link
              to="/scan"
              className={`px-2 py-1 rounded ${
                location.pathname === "/scan" ? "bg-blue-600 text-white" : "hover:bg-gray-700"
              }`}
            >
              Scan
            </Link>
            {session?.role === "admin" && (
              <Link
                to="/lookup"
                className={`px-2 py-1 rounded ${
                  location.pathname === "/lookup" ? "bg-blue-600 text-white" : "hover:bg-gray-700"
                }`}
              >
                Lookup
              </Link>
            )}
          </nav>
          <button
            onClick={onLogout}
            className="ml-auto text-sm text-gray-300 hover:text-white"
          >
            Logout
          </button>
        </div>
      </header>
      <main className="flex-1 max-w-3xl mx-auto w-full px-4 py-6">{children}</main>
    </div>
  );
}
